import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    toastifications: [],
    tldString: '',
    tldMap: {},
    mainsite: "",
    country: parseInt(localStorage.getItem("country")) || null, // 1 = Belgium, 2 = Netherlands
    lang: localStorage.getItem("lang") || null,

  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },

    setToastifications(state, toastifications) {
      state.toastifications = toastifications
    },

    SET_TLD_STRING(state, tld) {
      state.tldString = tld;
    },

    SET_TLD_MAP(state, tld) {
      state.tldMap = tld;
    },
    
    SET_MAINSITE(state, site) {
      state.mainsite = site;
    },
    setCountry(state, country) {
      state.country = country;
      if (country === null) {
        localStorage.removeItem("country");
        return;
      }
      localStorage.setItem("country", country);
    },
    setLocaleLang(state, lang) {
      state.lang = lang;
      if (lang === null) {
        localStorage.removeItem("lang");
        return;
      }
      localStorage.setItem("lang", lang);
    },

  },
  actions: {
    getTLDAndLanguage({ commit }, {url, defaultLang = 'nl'}) {
      if (!url) {
          commit('SET_TLD_MAP', {country: "", lang: ""});
          commit('SET_TLD_STRING', "");
          commit('SET_MAINSITE', new URL(location.href).origin);
          return;
      }
  
      try {
          const parsedUrl = new URL(url);
          
          // Extract TLD
          const hostname = parsedUrl.hostname;
          const parts = hostname.split('.');
          const tld = parts.length > 1 ? parts[parts.length - 1] : ''; // Get TLD, return empty string if not found
  
          // If the TLD is empty, return an empty string
          if (!tld) {
            commit('SET_TLD_MAP', {country: "", lang: ""});
            commit('SET_TLD_STRING', "");
            commit('SET_MAINSITE', new URL(location.href).origin);
            return;
          }
  
          // Extract the first path segment for language
          const pathSegments = parsedUrl.pathname.split('/').filter(Boolean); // Split and remove empty parts
          const language = (pathSegments.length > 0 && (pathSegments[0] === 'en' || pathSegments[0] === 'fr'))
              ? pathSegments[0]
              : defaultLang; // Default to provided default language if the first segment is invalid or empty
  
          // Concatenate TLD and language with a hyphen
          commit('SET_TLD_MAP', {country: tld, lang: language});
          commit('SET_TLD_STRING', `${tld}-${language}`);

          const site = parsedUrl.origin + (language === 'nl' ? '' : '/' + language);

          commit('SET_MAINSITE', site);
      } catch (error) {
        commit('SET_TLD_MAP', {country: "", lang: ""});
        commit('SET_TLD_STRING', "");
        commit('SET_MAINSITE', new URL(location.href).origin);
      }
    },
  },
  modules: {},
})
